module.exports = __webpack_public_path__ + "static/media/(000019).94f3ad98.jpg";